var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-trend"},[(_vm.label)?_c('div',{staticClass:"label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),(_vm.dataSet.length > 0)?_c('TrendChart',{attrs:{"padding":"3","interactive":true,"datasets":[
      {
        data: _vm.dataSet,
        smooth: true,
        fill: true,
        showPoints: true
      }
    ]},on:{"mouse-move":_vm.onMouseMove}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }